import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const FAQS = [
  {
    q: 'How do I get access after paying?',
    a: "Instantly. No account setup needed before you buy — enter your name and email, pay securely, and your program opens right away. You can set a password afterwards to log back in anytime.",
  },
  {
    q: 'Is this a subscription?',
    a: "No. It's a once-off payment with lifetime access. Pay once, keep it forever.",
  },
  {
    q: 'What if it doesn\'t work for me?',
    a: "You're covered by a 30-day money-back guarantee. If you're not seeing progress, you get a full refund — no questions asked.",
  },
  {
    q: 'Do I need equipment or a gym?',
    a: 'Most sessions need minimal equipment and can be done at home. Each video demonstration shows you exactly what to do and how to do it safely.',
  },
  {
    q: 'What if I get stuck or have questions?',
    a: 'You get direct 1:1 messaging support with me inside the platform — ask anything, anytime during your program.',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-20 sm:py-24 px-6 bg-[#F4EFE6] text-[#0B0B0B]" data-testid="faq-section">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-widest text-[#0B0B0B]/50 font-semibold mb-4">FAQ</div>
          <h2 className="text-4xl sm:text-5xl font-bold" style={{ fontFamily: 'Clash Display' }}>
            Questions? Answered.
          </h2>
        </div>
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-[#0B0B0B]/5 overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left font-semibold"
                data-testid={`faq-toggle-${i}`}
              >
                <span>{faq.q}</span>
                <ChevronDown className={`w-5 h-5 shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                  >
                    <p className="px-6 pb-5 text-[#0B0B0B]/70 leading-relaxed">{faq.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
